import { useClosetStore } from "@/store";
import { Input } from "../Input";

import styles from "./ToolBar.module.css";
import { ViewToggle } from "../ViewToggle";
import { useDebounce } from "use-debounce";
import { memo, useEffect, useRef } from "react";
import { trackSearch, trackSortChanged, trackViewModeChanged } from "@/services/analytics";

const SearchIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

function Toolbar() {
  const { searchQuery, viewMode, setSearchQuery, setViewMode, getClosetItems, setSortOption, sortOption } =
    useClosetStore();

  const [value] = useDebounce(searchQuery, 350);
  const previousValue = useRef("");

  useEffect(() => {
    if (value) {
      trackSearch(value);
      getClosetItems({ search: value });
      previousValue.current = value;
    } else if (!value && previousValue.current) {
      getClosetItems({
        search: ""
      });
      previousValue.current = "";
    }
  }, [value]);

  function handleSortChange(option: typeof sortOption) {
    trackSortChanged(option);
    setSortOption(option);
  }

  function handleViewModeChange(mode: typeof viewMode) {
    trackViewModeChanged(mode);
    setViewMode(mode);
  }

  return (
    <div className={styles.toolbar}>
      <div className={styles.searchBox}>
        <Input
          icon={<SearchIcon />}
          placeholder="Search items..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <select
        className={styles.sortSelect}
        value={sortOption}
        onChange={(e) => handleSortChange(e.target.value as typeof sortOption)}
      >
        <option value="newest">Newest</option>
        <option value="oldest">Oldest</option>
        <option value="a-to-z">A to Z</option>
        <option value="z-to-a">Z to A</option>
      </select>
      <ViewToggle mode={viewMode} onChange={handleViewModeChange} />
    </div>
  );
}

export default memo(Toolbar);
